import { isPaidSubscription } from '@/shared/lib/billing/isPaidSubscription';
import { Subscription } from '@/shared/types/Billing';

import { RECORDING_RELEASE_DATE } from './constants';

export const isPaidBeforeRecordingRelease = (subscription: null | Subscription | undefined): boolean =>
  isPaidSubscription(subscription) && Date.parse(subscription?.created ?? '') < Date.parse(RECORDING_RELEASE_DATE);
